import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { ContentDescription } from 'components/structures/general';
import { useMediaUp } from 'hooks';
import React, { FC } from 'react';
import { MultiDotsIcon, MultiLinesIcon, PlusIcon } from 'svgs';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(15, 0),
    },
  },
  boxCard: {
    position: 'relative',
    background: theme.palette.gradients.lightDarkGreenReverse,
    boxShadow: '0px 4px 23px rgba(85, 170, 136, 0.3)',
    borderRadius: theme.spacing(0, 4),
    padding: theme.spacing(10, 8),
    maxWidth: '100%',
    width: '100%',
    marginTop: theme.spacing(10),
    '& > *': {
      color: theme.palette.common.white,
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 0,
      maxWidth: 440,
      width: 'auto',
      minWidth: 515,
    },
  },
  listWrapper: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(6),
    '& li': {
      marginBottom: theme.spacing(2),
      '&::marker': { color: theme.palette.common.white },
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(4),
    },
  },
  multiLinesIcon: {
    marginLeft: theme.spacing(4),
    '& path': {
      stroke: theme.palette.common.white,
    },
  },
  whiteText: {
    color: theme.palette.common.white,
  },
  plusIcon: {
    position: 'absolute',
    top: theme.spacing(5),
    right: theme.spacing(5),
    transform: 'scale(0.6)',
    [theme.breakpoints.up('sm')]: {
      transform: 'scale(1)',
    },
  },
  multiDotsIcon: {
    position: 'absolute',
    top: theme.spacing(-8),
    left: theme.spacing(-8),
    zIndex: -1,
  },
  boxGrid: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const listItems: string[] = [
  'Wide coverage',
  'Lower cost compared to traditional marketing',
  'Availability of detailed information about the results of advertising campaigns',
  'Shorter sales cycle',
  'Assistance in building brand awareness',
  'Customer-centered experience',
  'Sales promotion',
];

const UndisputedBenefits: FC = () => {
  const isLargeUp = useMediaUp('lg');
  const classes = useStyles();
  return (
    <Box className={classes.wrapper}>
      <Container fixed>
        <Grid spacing={isLargeUp ? 6 : 0} direction={isLargeUp ? 'row' : 'column-reverse'} container>
          <Grid lg={6} xs={12} className={classes.boxGrid} item>
            <Box className={classes.boxCard}>
              {isLargeUp && <MultiDotsIcon className={classes.multiDotsIcon} />}
              <PlusIcon className={classes.plusIcon} />
              <Box display="flex" alignItems="center">
                <Typography className={classes.whiteText} variant="h4">
                  Benefits:
                </Typography>
                <MultiLinesIcon className={classes.multiLinesIcon} />
              </Box>
              <Typography className={classes.listWrapper} component="ul">
                {listItems.map((item) => (
                  <Typography key={item} component="li">
                    {item}
                  </Typography>
                ))}
              </Typography>
            </Box>
          </Grid>
          <Grid lg={6} xs={12} item>
            <ContentDescription
              title={{ text: 'Undisputed benefits' }}
              upperTitle={{ text: 'Leading experts' }}
              text={{
                text: 'To take advantage of these benefits, you need to decide on the type of digital marketing. Each of them is used to achieve different goals, according to which they are chosen during the development of the strategy. With US Software Solutions, you will get to work with a team of experts with years of combined experience who will help you make the right choice.',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default UndisputedBenefits;
